module.exports = __webpack_public_path__ + "assets/img/6.55ca229b.png";